import type { VehicleInterest } from '../types/lead'

/**
 * The models the Queens deliver most.
 *
 * Deliberately carries NO price, MSRP, monthly payment, "starting at", lease figure,
 * incentive amount, trim level, or availability claim — those are the dealership's to
 * publish, and they change. A model name and a lifestyle line are all this section makes.
 *
 * Each photo slot stays empty until an official Kia press photo is dropped in.
 */
export interface ModelCard {
  id: Extract<VehicleInterest, 'telluride' | 'sportage' | 'sorento' | 'k5' | 'ev' | 'carnival'>
  name: string
  line: string
  /** REPLACE WITH OFFICIAL KIA PRESS PHOTO. Empty renders a labeled placeholder. */
  photo: string
}

export const MODELS: ModelCard[] = [
  {
    id: 'telluride',
    name: 'Telluride',
    line: 'wanted.telluride',
    photo: 'https://cdn.magicpatterns.com/uploads/21wqmzgCBxkVpBnKQrcGrw/image.png',
  },
  {
    id: 'sportage',
    name: 'Sportage',
    line: 'wanted.sportage',
    photo: 'https://cdn.magicpatterns.com/uploads/vrtbt6g1biWZt28enYPVbU/image.png',
  },
  {
    id: 'sorento',
    name: 'Sorento',
    line: 'wanted.sorento',
    photo:
      'https://cdn.magicpatterns.com/uploads/43ib6MxMcJsNMrQzUfKhu8/Captura_de_pantalla_2026-08-07_a_la(s)_3.41.05_p._m..png',
  },
  {
    id: 'k5',
    name: 'K5',
    line: 'wanted.k5',
    photo:
      'https://cdn.magicpatterns.com/uploads/788r8Gx5A4LpqcWTzFLMtc/Captura_de_pantalla_2026-08-07_a_la(s)_3.46.38_p._m..png',
  },
  {
    id: 'ev',
    name: 'EV6 / EV9',
    line: 'wanted.ev',
    photo:
      'https://cdn.magicpatterns.com/uploads/vXvWAq8NVxxZGA4ScgitWE/Captura_de_pantalla_2026-08-07_a_la(s)_3.53.24_p._m..png',
  },
  // Sixth card so the 3-up desktop grid fills two complete rows.
  {
    id: 'carnival',
    name: 'Carnival',
    line: 'wanted.carnival',
    photo: 'https://cdn.magicpatterns.com/uploads/gHQfyJjoRgZmH7ysNTtouF/image.png',
  },
]
